// Agent tools API: GET /api/v1/owner/agents/{agentId}/capabilities
// via the shared/api client singleton.

import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import type { AgentToolsView } from '../model/toolTypes';

interface RawAgentTool {
  name: string;
  description: string;
}

interface RawAgentMCPTool extends RawAgentTool {
  tools: RawAgentTool[];
}

interface RawAgentToolsInfo {
  agent_id: string;
  tools: RawAgentTool[];
  mcps: RawAgentMCPTool[];
}

function getClient() {
  return createApiClient({
    baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
    auth: { getToken },
  });
}

export async function fetchAgentTools(agentId: string): Promise<AgentToolsView> {
  const raw = await getClient().request<RawAgentToolsInfo>({
    path: `/api/v1/owner/agents/${encodeURIComponent(agentId)}/capabilities`,
  });
  return {
    agentId: raw.agent_id,
    tools: raw.tools.map((t) => ({ name: t.name, description: t.description })),
    mcps: raw.mcps.map((m) => ({
      name: m.name,
      description: m.description,
      tools: m.tools.map((t) => ({ name: t.name, description: t.description })),
    })),
  };
}
